import { motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const MyselfHead = () => {
  return (
    <MyselfHeadDiv>

      <div className="MyselfBox">

        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            ease: [0.65, 0, 0.35, 1],
            duration: 1,
            delay: 1
          }}
          className="myHeadHeading">
          <h1> Transforming Concepts into </h1>
          <h1> High-Performance Realities </h1>
        </motion.div>

        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            ease: [0.65, 0, 0.35, 1],
            duration: 1,
            delay: 1
          }}
          className="line" />
      </div>
    </MyselfHeadDiv>
  )
}

export default MyselfHead

const MyselfHeadDiv = styled(motion.div)`
  padding-top: 14rem;
  padding-bottom: 10rem;

  .MyselfBox{
    display: flex;
    flex-direction: column;
    row-gap: 3rem;
    padding-left: 15rem;
    padding-right: 10rem;
    
    @media only screen and (max-width: 1365px) {
      padding-left: 10rem !important;
      padding-right: 5rem !important;
    }

    @media only screen and (max-width: 1190px) {
      padding-left: 5rem !important;
      padding-right: 2rem !important;
    }

    @media only screen and (max-width: 645px) {
      padding-left: 2rem !important;
      padding-right: 2rem !important;
    }
  }

  h1{
    font-size: 6rem;
    font-weight: 400;
    font-family: var(--font7);

    @media only screen and (max-width: 1365px) {
      font-size: 4rem !important;
    }

    @media only screen and (max-width: 1196px) {
      font-size: 3rem !important;
    }

    @media only screen and (max-width: 840px) {
      font-size: 2rem !important;
    }

    @media only screen and (max-width: 510px) {
      font-size: 1.5rem !important;
    }

    }
  }
`